import script from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=7ce23efb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce23efb"]])

export default __exports__